((LotNumber, $) => {

    const $dom = {};

    const cacheDom = () => {
      $dom.LotSubmit = $('.lot-checker__button');
      $dom.LotField = $('.lot-checker__field');
      $dom.LotError = $('.lot-checker__error');
    };


    LotNumber.init = () => {
        cacheDom();
        checkLot();
      };

    const checkLot = () => {
        $dom.LotSubmit.click(function() {
            var getVal = $dom.LotField.val();
            var assetPath = 'https://cdn.shopify.com/s/files/1/0330/6521/files/COA-'+ getVal +'.pdf'
            $.get(assetPath)
                .done(function() {
                    window.open(assetPath);
                    $dom.LotError.addClass("lot-checker__error--hidden");
                }).fail(function() {
                    $dom.LotError.attr('aria-hidden', 'false');
                    $dom.LotError.removeClass("lot-checker__error--hidden");
                })
        });
    };

  })(window.LotNumber = window.LotNumber || {}, jQuery);